/* eslint-disable no-nested-ternary */
import styled, { css } from "styled-components";
import { COMPONENTS, SPACING } from "../../../constants/design/spacing";

export const Container = styled.div<{ hideLastCol?: boolean }>`
  display: grid;
  grid-template-columns: minmax(auto, ${COMPONENTS.portfolioSideTab}px) 3fr minmax(
      auto,
      ${({ hideLastCol }) => (hideLastCol ? 0 : COMPONENTS.portfolioSideTab)}px
    );
  grid-gap: ${SPACING.two}px;
  margin-left: ${SPACING.two}px;
  position: relative;
  height: 100%;
  > * {
    height: inherit;
  }

  overflow: hidden;

  ${({ hideLastCol }) =>
    hideLastCol &&
    css`
      > :last-child {
        display: none;
      }
    `}
`;
